document.addEventListener("DOMContentLoaded", function () {
  const revealElements = document.querySelectorAll(".reveal-element");

  if ("IntersectionObserver" in window) {
    const observerOptions = {
      root: null,
      rootMargin: "0px",
      threshold: 0.15 // Triggers animation when 15% of the element is visible
    };

    const elementObserver = new IntersectionObserver(function (entries, observer) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add("is-visible");
          observer.unobserve(entry.target); // Runs the animation only once
        }
      });
    }, observerOptions);

    revealElements.forEach(function (element) {
      elementObserver.observe(element);
    });
  } else {
    // Fallback if older browsers don't support IntersectionObserver
    revealElements.forEach(function (element) {
      element.classList.add("is-visible");
    });
  }
});